import { render, staticRenderFns } from "./FootDouble2230.vue?vue&type=template&id=c1cd5272"
import script from "./FootDouble2230.vue?vue&type=script&lang=js"
export * from "./FootDouble2230.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports